import { useSyncExternalStore } from 'react';

type Listener = () => void;

export class DataStore<T> {
  private state: T;
  private listeners = new Set<Listener>();

  constructor(initialState: T) {
    this.state = initialState;
  }

  getSnapshot = (): T => {
    return this.state;
  };

  setState = (nextState: T): void => {
    this.state = nextState;
    this.listeners.forEach((listener) => listener());
  };

  subscribe = (listener: Listener): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };
}

export const useDataStore = <T, S>(store: DataStore<T>, selector: (state: T) => S): S => {
  return useSyncExternalStore(store.subscribe, () => selector(store.getSnapshot()));
};
